// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xGDQahUue_VUs1KHGQ4r {
    margin-bottom: 16px;
}

.xnT_zSA5bw8UcXXIuOmN {
    align-items: center;
    background-color: white;
    display: flex;
    margin-top: 16px;
    padding: 16px;
    justify-content: space-between;
}

.IIMEYbjxm6YOr6qiyvpV, .NqNv0GTDwNDbcJbfBGnG {
    display: flex;
    align-items: center;
}

.Orzqw5umynVki4M8vYZ3 {
    display: inline-block;
    font-size: 16px;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.Orzqw5umynVki4M8vYZ3 + .Orzqw5umynVki4M8vYZ3 {
    margin-left: 16px;
}

.IMUy3N4QcTnPZPgCBfd3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.rPhAIkCxUsxm3j7Q68qs {
    display: flex;
}

.OMC2WAnSQAj6s6lSQLDl {
    margin-top: 16px;
    width: 30%;
}

.LYU04TXTyeA1rEfrOeQd {
    margin-left: 16px;
    margin-top: 16px;
    width: 70%;
}

.gtLyJ0__mRT7NjijBvyA {
    padding: 0 6px;
}

/* Some minor overrides for the tab navigation styles provided by Bootstrap */
.LYU04TXTyeA1rEfrOeQd .panel-heading {
    font-weight: 600;
}

.aKmZuRWer7vQ_sbWCTDF {
    border-bottom: 0;
    font-size: 90%;
    font-weight: 600;
}

.aKmZuRWer7vQ_sbWCTDF > li > a {
    background-color: transparent;
    border-color: #ddd;
    border-style: solid;
    border-width: 1px 1px 0 1px;
}

.aKmZuRWer7vQ_sbWCTDF > li.active > a {
    background-color: #f5f5f5;
}

.aKmZuRWer7vQ_sbWCTDF > li > a:hover {
    border-color: #ddd;
    border-style: solid;
    border-width: 1px 1px 0 1px;
}

.aKmZuRWer7vQ_sbWCTDF > li.active > a:hover {
    background-color: #f5f5f5;
}

.xGDQahUue_VUs1KHGQ4r .panel:first-child {
    border-top-left-radius: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile/components/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".profile {\n    margin-bottom: 16px;\n}\n\n.header {\n    align-items: center;\n    background-color: white;\n    display: flex;\n    margin-top: 16px;\n    padding: 16px;\n    justify-content: space-between;\n}\n\n.labels, .controls {\n    display: flex;\n    align-items: center;\n}\n\n.label {\n    display: inline-block;\n    font-size: 16px;\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.label + .label {\n    margin-left: 16px;\n}\n\n.navigation {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.container {\n    display: flex;\n}\n\n.sidebar {\n    margin-top: 16px;\n    width: 30%;\n}\n\n.content {\n    margin-left: 16px;\n    margin-top: 16px;\n    width: 70%;\n}\n\n.divider {\n    padding: 0 6px;\n}\n\n/* Some minor overrides for the tab navigation styles provided by Bootstrap */\n.content :global(.panel-heading) {\n    font-weight: 600;\n}\n\n.sections {\n    border-bottom: 0;\n    font-size: 90%;\n    font-weight: 600;\n}\n\n.sections > :global(li > a) {\n    background-color: transparent;\n    border-color: #ddd;\n    border-style: solid;\n    border-width: 1px 1px 0 1px;\n}\n\n.sections > :global(li.active > a) {\n    background-color: #f5f5f5;\n}\n\n.sections > :global(li > a:hover) {\n    border-color: #ddd;\n    border-style: solid;\n    border-width: 1px 1px 0 1px;\n}\n\n.sections > :global(li.active > a:hover) {\n    background-color: #f5f5f5;\n}\n\n.profile :global(.panel:first-child) {\n    border-top-left-radius: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `xGDQahUue_VUs1KHGQ4r`,
	"header": `xnT_zSA5bw8UcXXIuOmN`,
	"labels": `IIMEYbjxm6YOr6qiyvpV`,
	"controls": `NqNv0GTDwNDbcJbfBGnG`,
	"label": `Orzqw5umynVki4M8vYZ3`,
	"navigation": `IMUy3N4QcTnPZPgCBfd3`,
	"container": `rPhAIkCxUsxm3j7Q68qs`,
	"sidebar": `OMC2WAnSQAj6s6lSQLDl`,
	"content": `LYU04TXTyeA1rEfrOeQd`,
	"divider": `gtLyJ0__mRT7NjijBvyA`,
	"sections": `aKmZuRWer7vQ_sbWCTDF`
};
export default ___CSS_LOADER_EXPORT___;
